import { render, staticRenderFns } from "./accessList.vue?vue&type=template&id=42d087e9&scoped=true&"
import script from "./accessList.vue?vue&type=script&lang=js&"
export * from "./accessList.vue?vue&type=script&lang=js&"
import style0 from "./accessList.vue?vue&type=style&index=0&id=42d087e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d087e9",
  null
  
)

export default component.exports